import {
  createQueryString,
  fetch,
  getEnv,
  getErrorData,
  getResponseData,
  safeJsonStringify,
} from "app/utils";
import { ApiUrls } from "./constants";
import {VoucherValidationResponseInterface} from "../interfaces/passenger";

export const getConfig = async (payload: object | undefined): Promise<any> => {
  if (typeof payload === "undefined") {
    payload = {
      initReq: "",
      t: new Date().getTime(),
      CLIENT_CODE: getEnv("CUSTOMER_SOLUTION"),
    };
  }
  const queryString = createQueryString(payload);
  const url = `${ApiUrls.Config}?${queryString}`;

  try {
    const response = await fetch(url);
    return getResponseData(response);
  } catch (error) {
    throw getErrorData(error);
  }
};

export const retrievePools = async (payload: object | string): Promise<any> => {
  try {
    const response = await fetch(ApiUrls.Pools, {
      method: "post",
      data: payload,
    });
    return getResponseData(response);
  } catch (error) {
    throw getErrorData(error);
  }
};

export const calculateAvailability = async (
  payload: object | string,
): Promise<any> => {
  try {
    const response = await fetch(ApiUrls.Availability, {
      method: "post",
      data: payload,
    });
    return getResponseData(response);
  } catch (error) {
    throw getErrorData(error);
  }
};

export const validateVouchers = async (
  payload: object | string,
): Promise<VoucherValidationResponseInterface> => {
  try {
    const response = await fetch(ApiUrls.VoucherValidation, {
      method: "post",
      data: payload,
    });
    return getResponseData(response);
  } catch (error) {
    throw getErrorData(error);
  }
};

// TODO: rename?
export const encrypt = async (payload: object | string): Promise<any> => {
  const queryString = createQueryString(payload);
  const url = `${ApiUrls.Encrypt}?${queryString}`;

  try {
    const response = await fetch(url);
    return getResponseData(response);
  } catch (error) {
    throw getErrorData(error);
  }
};

export const obtain3DParameters = async (
  transactionId: string,
): Promise<any> => {
  const url = `${ApiUrls.Obtain3DParameters}/${transactionId}`;

  try {
    const response = await fetch(url);
    return getResponseData(response);
  } catch (error) {
    throw getErrorData(error);
  }
};

export const initTransaction = async (
  payload: object | string,
): Promise<any> => {
  try {
    const response = await fetch(ApiUrls.InitTransaction, {
      method: "post",
      data: payload,
    });
    return getResponseData(response);
  } catch (error) {
    throw getErrorData(error);
  }
};

export const createBooking = async (payload: object | string): Promise<any> => {
  try {
    const response = await fetch(ApiUrls.Booking, {
      method: "post",
      data: payload,
    });
    return getResponseData(response);
  } catch (error) {
    throw getErrorData(error);
  }
};

export const validateFqtv = async (payload: object | string): Promise<any> => {
  try {
    const response = await fetch(ApiUrls.FqtvValidation, {
      method: "post",
      data: payload,
    });
    return getResponseData(response);
  } catch (error) {
    return false;
  }
};

export const saveToLog = async (payload: any): Promise<any> => {
  try {
    await fetch(ApiUrls.Logging, {
      method: "post",
      data: payload,
    });
  } catch (error) {
    throw getErrorData(error);
  }
};

export const saveToErrorLog = async (payload: any): Promise<any> => {
  try {
    const response = await fetch(ApiUrls.ErrorLogging, {
      method: "post",
      data: safeJsonStringify(payload),
    });
    return getResponseData(response);
  } catch (error) {
    throw getErrorData(error);
  }
};

export const getToken = async (payload: object | string): Promise<any> => {
  try {
    const response = await fetch(ApiUrls.Token, {
      method: "post",
      data: payload,
    });
    return getResponseData(response);
  } catch (error) {
    throw getErrorData(error);
  }
};

export const checkPaymentData = async (
  payload: object | string,
): Promise<any> => {
  try {
    const response = await fetch(ApiUrls.PaymentData, {
      method: "post",
      data: payload,
    });
    return getResponseData(response);
  } catch (error) {
    throw getErrorData(error);
  }
};

export const setPaymentStatus = async (
  payload: object | string,
): Promise<any> => {
  const queryString = createQueryString(payload);
  const url = `${ApiUrls.PaymentStatus}?${queryString}`;

  try {
    const response = await fetch(url);
    return getResponseData(response);
  } catch (error) {
    throw getErrorData(error);
  }
};

export const paymentLogging = (payload: object | string): void => {
  try {
    fetch(ApiUrls.PaymentLogging, {
      method: "post",
      data: payload,
    });
  } catch (error) {
    throw getErrorData(error);
  }
};

export const changeLanguage = async (lang: string): Promise<any> => {
  const url = `${ApiUrls.ChangeLanguage}/${lang}`;
  fetch(url, {
    method: "post",
  });
};
